import { Col, Row } from "antd";
import React from "react";
import LazyLoad from "react-lazyload";

import Forecast from "../Forecast";
import TechnicalOverview from "../TechnicalOverview";
import styles from "./style.module.scss";

const Headline = ({ product }) => {
  const forecastExist =
    product.acf.product_analysis_forecast_chart !== null &&
    product.acf.product_analysis_forecast_chart !== ""
      ? true
      : false;
  return (
    <Row 
      gutter={[12, 20]}
    >
      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 16, offset: `${forecastExist ? 0 : 4}` }}
        className={styles.colTechnicalOverview}
      >
        <LazyLoad>
          <TechnicalOverview product={product} />
        </LazyLoad>
      </Col>
        {forecastExist ? (
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} className={styles.colForecast}>
            <LazyLoad>
              <Forecast product={product} />
            </LazyLoad>
          </Col>
        ) : null}
    </Row>
  );
};
export default Headline;
